<script>
import { alertService } from "../../services";
import { required } from "vuelidate/lib/validators";
import config from "../../config";
import { error_message, success_message } from "../../Helper/helper";
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import { routes } from "../../config/api_routes";
export default {
  components: { alertService, Layout, PageHeader },
  data() {
    return {
      products: "",
      subProducts: [],
      typeform: {
        product_id: "",
        subproduct_id: "",
        status: "",
        name: "",
        value: "",
      },
    };
  },
  validations: {
    typeform: {
      product_id: {
        required,
      },
      subproduct_id: {
        required,
      },
      name: {
        required,
      },
      value: {
        required,
      },
      status: {
        required,
      },
    },
  },

  methods: {
    getAlertById() {
      alertService
        .getAlertById({ id: this.$route.params.id })
        .then((response) => {
          this.typeform = response.data.result;
          this.typeform.alert_id = this.$route.params.id;
          this.getSubProductById("", response.data.result.product_id);
        });
    },

    getSubProductById(event, product_id) {
      if (product_id) {
        this.subProduct_id = product_id;
      } else {
        this.subProduct_id = event.target.value;
      }
      alertService
        .getSubProducts({ subProduct_id: this.subProduct_id })
        .then((response) => {
          if (response.data.code === 200) {
            // this.subProducts = response.data.result;
            this.subProducts = response.data.result.sort((a, b) => {
              return a.sub_product_name.localeCompare(b.sub_product_name);
            });
          }
        });
    },

    getProducts() {
      alertService.getProducts().then((response) => {
        if (response.data.code === 200) {
          // this.products = response.data.result;
          this.products = response.data.result.sort((a, b) => {
            return a.item_name.localeCompare(b.item_name);
          });
        }
      });
    },

    editAlert() {
      this.$v.typeform.$touch();
      if (this.$v.typeform.$invalid) {
        return;
      } else {
        const fd = new FormData();
        alertService.updateAlert({ ...this.typeform }).then((response) => {
          if (response.data.code === 200) {
            success_message(response.data.message);
            this.$router.push({ name: "alert-list" });
          } else {
            error_message(response.data.message);
          }
        });
      }
    },
  },
  mounted() {
    this.getProducts();
    this.getAlertById();
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div
          class="
            page-title-box
            d-flex
            align-items-center
            justify-content-between
            icon-main-page
          "
        >
          <div class="page-title-left avatar-main-icon">
            <div class="avatar-xs mr-3">
              <span
                class="
                  avatar-title
                  rounded-circle
                  bg-soft-primary
                  text-primary
                  font-size-18
                "
              >
                <i class="bx bx-briefcase"></i>
              </span>
            </div>
            <div class="report-tag">
              <h4 class="mb-0 font-size-18">{{ typeform.product_name }}</h4>
              <p>
                <router-link :to="{ name: 'alert-list' }">{{
                  trans.get("__JSON__.Alerts")
                }}</router-link>
                > {{ typeform.product_name }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <form action="" @submit.prevent="editAlert">
          <div class="card">
            <div class="card-body">
              <p class="card-title-desc"></p>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="required">{{
                      trans.trans("__JSON__.Product")
                    }}</label>
                    <select
                      v-model="$v.typeform.product_id.$model"
                      class="custom-select"
                      id="product_id"
                      name="product_id"
                      @change="getSubProductById($event, '')"
                      :class="{ 'is-invalid': $v.typeform.product_id.$error }"
                    >
                      <option value="">
                        {{ trans.get("__JSON__.Select Product") }}
                      </option>
                      <option
                        v-for="product in products"
                        :key="product.id"
                        v-text="product.item_name"
                        :value="product.id"
                      ></option>
                    </select>
                    <div
                      v-if="$v.typeform.product_id.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.product_id.required">{{
                        trans.get("__JSON__.Please select product")
                      }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="required">{{
                      trans.trans("__JSON__.Sub Product")
                    }}</label>
                    <select
                      class="custom-select"
                      id="subproduct_id"
                      name="subproduct_id"
                      v-model="typeform.subproduct_id"
                      :class="{
                        'is-invalid': $v.typeform.subproduct_id.$error,
                      }"
                    >
                      <option value="">
                        {{ trans.get("__JSON__.Select Sub Product") }}
                      </option>
                      <option
                        v-for="subProduct in subProducts"
                        :key="subProduct.id"
                        v-text="subProduct.sub_product_name"
                        :value="subProduct.subproduct_id"
                      ></option>
                    </select>
                    <div
                      v-if="$v.typeform.subproduct_id.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.subproduct_id.required">{{
                        trans.get("__JSON__.Please select SubProduct")
                      }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="required">{{
                      trans.trans("__JSON__.Name")
                    }}</label>
                    <!-- <input
                      id="name"
                      type="text"
                      class="form-control"
                      :placeholder="trans.trans('__JSON__.Quantity/Box')"
                      name="name"
                      v-model="$v.typeform.name.$model"
                      :class="{ 'is-invalid': $v.typeform.name.$error }"
                    /> -->
                    <select
                      class="custom-select"
                      name="name"
                      id="name"
                      v-model="$v.typeform.name.$model"
                      :class="{ 'is-invalid': $v.typeform.name.$error }"
                    >
                      <option value="">Select Type</option>
                      <option value="quantity">Quantity</option>
                    </select>
                    <div
                      v-if="$v.typeform.name.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.name.required">{{
                        trans.get("__JSON__.Please enter type")
                      }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="required">{{
                      trans.trans("__JSON__.Value")
                    }}</label>
                    <input
                      id="value"
                      type="number"
                      class="form-control"
                      name="value"
                      v-model="$v.typeform.value.$model"
                      :class="{ 'is-invalid': $v.typeform.value.$error }"
                    />
                    <div
                      v-if="$v.typeform.value.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.value.required">{{
                        trans.get("__JSON__.Please enter quantity")
                      }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6 vendor-status">
                  <b-form-group
                    id="input-group-1"
                    :label="trans.get('__JSON__.Status')"
                    label-for="status"
                  >
                    <label class="switch">
                      <input
                        type="checkbox"
                        id="togBtn"
                        name="status"
                        class="switch-on"
                        true-value="1"
                        false-value="0"
                        v-model="typeform.status"
                      />
                      <div class="slider round">
                        <span class="on">{{
                          trans.get("__JSON__.Active")
                        }}</span>
                        <span class="off">{{
                          trans.get("__JSON__.Inactive")
                        }}</span>
                      </div>
                    </label>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <button class="btn btn-primary mr-1 mt-3">
                    {{ trans.get("__JSON__.Update Alert") }}
                  </button>
                  <!-- <b-button
                    @click="$router.go(-1)"
                    type="button"
                    variant="secondary"
                    class="mt-3"
                    >{{ trans.get("__JSON__.Cancel") }}</b-button
                  > -->
                  <router-link
                    :to="{name:'alert-list'}"
                  >
                    <b-button
                      type="button"
                      variant="secondary"
                      class="mt-3"
                      >{{ trans.get("__JSON__.Cancel") }}</b-button
                    >
                  </router-link>  
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </Layout>
</template>